import { date, object, string } from 'yup';
import dayjs from 'dayjs';

import {
  DATE_IN_PAST,
  DATE_AFTER_CONTRACT_END_PLUS_1,
  REQUIRED_FIELD
} from '@/config/text.const';

export const validationSchema = object().shape({
  statusChangeComment: string()
    .max(100, 'Must be maximum ${max} characters')
    .required(REQUIRED_FIELD),

  statusChangeDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), DATE_IN_PAST)
    .required('You must enter a date')
    .test((value, { options, createError }) => {
      const contractEndDate = dayjs(options?.context?.contract?.contractEndDate ?? null)?.add(1, 'day');
      const contractRenewableTerm = options?.context?.contract?.renewableTerm ?? null;

      const selectedDate = dayjs(value ?? null);
      if (!contractRenewableTerm && selectedDate.isAfter(contractEndDate, 'date')) {
        return createError({
          message: DATE_AFTER_CONTRACT_END_PLUS_1
        });
      }
      return true;
    }),

});
